import script from "./RequestsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsListView.vue?vue&type=script&setup=true&lang=js"

import "./RequestsListView.vue?vue&type=style&index=0&id=b473e3ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b473e3ce"]])

export default __exports__